import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_PARTNER_EBC_ID } from '../constants/ebon';

import { ebonSellingPriceTotal, createEbon, compareEbons } from './ebonUtils';

const mergeItems = (acc, next) => {
    const found = acc.findIndex(item => item.value === next.value);

    if (found > -1) acc[found].stock += 1;
    else acc.push({ ...next });

    return acc;
};

const vendorClusterMap = {
    Fnac: 'Fnac / Darty',
    Darty: 'Fnac / Darty'
};

export const getVendorName = (name, isEnterpriseCard) => {
    if (isEnterpriseCard) {
        return ENTERPRISE_CARD_NAME;
    }

    return vendorClusterMap[name] || name;
};

export const createOrder = (
    { orderDate, ebonList, id, billNumber, partnerId, paymentRequest },
    ebonPartners
) => {
    const partner =
        ebonPartners.length > 0 && ebonPartners.filter(partner => partner.id === partnerId);
    const isEnterpriseCard =
        partner.length > 0 && partner[0].ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID;
    const vendorName = partner.length > 0 && getVendorName(partner[0].name, isEnterpriseCard);

    const items = ebonList.map(ebon => createEbon({ ...ebon, vendorName })).sort(compareEbons);
    return {
        vendorName,
        id,
        date: orderDate,
        items,
        mergedItems: items.reduce(mergeItems, []).sort(compareEbons),
        total: ebonList.reduce(ebonSellingPriceTotal, 0),
        billNumber,
        partnerId,
        paymentRequest,
        isEnterpriseCard
    };
};



// WEBPACK FOOTER //
// ./src/utils/ebonOrderUtils.js